import type { FC } from "preact/compat";
import { Navigate } from "react-router-dom";
import { me, useApp } from "~/core/store";
import { useBreakpoint } from "~/hooks";

const INSTALLATION_REGEX = /\/me\/(\w+)\/\w+\//;

// @LINK @DEP controlled by layouts/Main/Visits
const getRedirect = (md: boolean) => {
    if (md) {
        return null;
    }

    try {
        const visits: [string, string][] =
            JSON.parse(localStorage.getItem("v1_app_visits") ?? "{}").last ??
            [];

        if (visits.length === 0) {
            return null;
        }

        const [path] = visits[0];
        const match = path.match(INSTALLATION_REGEX);

        if (!match) {
            return null;
        }

        return [path, match[1]] as const;
    } catch {
        return null;
    }
};

const Redirect: FC = () => {
    const {
        api: { connection, installation },
    } = useApp();
    const bpMd = useBreakpoint("md");
    const redirect = getRedirect(bpMd.peek());

    if (!connection.value) {
        const finalTo = redirect
            ? `/p/login?continue=${encodeURIComponent(redirect[0])}&installation=${redirect[1]}`
            : "/p/login";

        return <Navigate replace to={finalTo} />;
    }

    const finalTo =
        redirect && redirect[1] === installation.peek()
            ? redirect[0]
            : me("dashboard");

    return <Navigate replace to={finalTo} />;
};

export default Redirect;
